import { apiV2 } from './http';
import type {
  ReportPeriod,
  ReportTableState,
  StoreGroupReportClients,
  StoreGroupReportFlow,
  StoreGroupReportOrders,
  StoreGroupReportStores,
  StoreGroupReportSummary,
} from './interfaces/storeGroupReport';

const BASE_PATH = 'store-groups';

export async function getStoreGroupReportSummary(
  storeGroupId: number,
  period: ReportPeriod,
  idi?: string,
): Promise<StoreGroupReportSummary> {
  const res = await apiV2.get<StoreGroupReportSummary>(
    `${BASE_PATH}/${storeGroupId}/report/summary`,
    { params: { ...period, idi } },
  );
  return res.data;
}

export async function getStoreGroupReportOrders(
  storeGroupId: number,
  period: ReportPeriod,
  table: ReportTableState,
  idi?: string,
): Promise<StoreGroupReportOrders> {
  const res = await apiV2.get<StoreGroupReportOrders>(
    `${BASE_PATH}/${storeGroupId}/report/orders`,
    { params: { ...period, ...table, idi } },
  );
  return res.data;
}

export async function getStoreGroupReportClients(
  storeGroupId: number,
  period: ReportPeriod,
  table: ReportTableState,
  idi?: string,
): Promise<StoreGroupReportClients> {
  const res = await apiV2.get<StoreGroupReportClients>(
    `${BASE_PATH}/${storeGroupId}/report/clients`,
    { params: { ...period, ...table, idi } },
  );
  return res.data;
}

// Sem idi: o ranking compara lojas entre si.
export async function getStoreGroupReportStores(
  storeGroupId: number,
  period: ReportPeriod,
  table: ReportTableState,
): Promise<StoreGroupReportStores> {
  const res = await apiV2.get<StoreGroupReportStores>(
    `${BASE_PATH}/${storeGroupId}/report/stores`,
    { params: { ...period, ...table } },
  );
  return res.data;
}

// Sem idi, sem paginação: o fluxo compara lojas entre si.
export async function getStoreGroupReportFlow(
  storeGroupId: number,
  period: ReportPeriod,
): Promise<StoreGroupReportFlow> {
  const res = await apiV2.get<StoreGroupReportFlow>(
    `${BASE_PATH}/${storeGroupId}/report/flow`,
    { params: period },
  );
  return res.data;
}
